import { chainReducers } from 'src/utils/chainReducers';
import { ItemImageUploadState } from 'src/react/itemImageUpload/state/ItemImageUploadState';
import { itemImageUploadResetReducer } from 'src/react/itemImageUpload/reducers/itemImageUploadResetReducer';
import { itemImageUploadUploadReducer } from 'src/react/itemImageUpload/reducers/itemImageUploadUploadReducer';

export const itemImageUploadReducer = chainReducers<ItemImageUploadState>(
    itemImageUploadResetReducer,
    itemImageUploadUploadReducer,
);
